{
  "platform": "Platform",
  "partner": "Partner",
  "tenants": "Tenants",
  "customers": "Customers",
  "partners": "Partners",
  "enquiries": "Enquiries",
  "teamAccess": "Team & access",
  "tenant": "Tenant",
  "yourTenants": "Your tenants",
  "noTenantAssignments": "No tenant assignments yet.",
  "noPartnerCustomersYet": "This partner has no customers yet.",
  "onboarding": "Onboarding",
  "overview": "Overview",
  "users": "Users",
  "groups": "Groups",
  "designer": "Designer",
  "rules": "Rules",
  "campaigns": "Campaigns",
  "tester": "Tester"
}
